import { GenericSelectData } from "~/components/select/SelectGeneric";
import { VolumePoolStatus } from "~/gql/graphqlBase.generated";

export interface VolumePoolOptionSource {
	name: string;
	status?: VolumePoolStatus | null;
	volumePoolId: string;
}

const byName = (a: GenericSelectData, b: GenericSelectData) => a.name.localeCompare(b.name);

export const buildDisabledVolumePoolOptions = (
	pools: VolumePoolOptionSource[],
	knownDisabledPools: VolumePoolOptionSource[],
	selectedIds: string[]
): GenericSelectData[] => {
	const selected = new Set(selectedIds);
	const options = new Map<string, GenericSelectData>();
	for (const pool of [...knownDisabledPools, ...pools]) {
		if (pool.status !== VolumePoolStatus.Active && !selected.has(pool.volumePoolId)) continue;
		options.set(pool.volumePoolId, { code: pool.volumePoolId, name: pool.name });
	}
	for (const id of selectedIds) {
		if (!options.has(id)) options.set(id, { code: id, name: id });
	}
	return [...options.values()].sort(byName);
};

export const toDisabledVolumePoolValue = (options: GenericSelectData[], selectedIds: string[]): GenericSelectData[] => {
	const byId = new Map(options.map((option) => [option.code, option]));
	return selectedIds.map((id) => byId.get(id) ?? { code: id, name: id });
};

export const haveDisabledVolumePoolsChanged = (current: string[], initial: string[]): boolean => {
	const currentSet = new Set(current);
	const initialSet = new Set(initial);
	if (currentSet.size !== initialSet.size) return true;
	for (const id of currentSet) {
		if (!initialSet.has(id)) return true;
	}
	return false;
};
